import React from 'react';
import universal from 'react-universal-component';

import { Skeleton } from 'app/modules/Betting';

export default universal(() => import('./Live'), {
  loading: () => (
    <Skeleton />
  ),
});
